'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

export type HrProps = React.HTMLAttributes<HTMLHRElement> & UiSkeletonProps;

const sk = SKELETON_BY_COMPONENT.Hr;

const Hr = forwardRef<HTMLHRElement, HrProps>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  if (sk.voidLike && showSkeleton) {
    return (
      <span
        ref={ref as React.Ref<HTMLSpanElement>}
        className={cn('skeleton', `skeleton-${sk.shape}`, className)}
        aria-hidden
      />
    );
  }

  return (
    <hr       ref={ref}
      className={cn('group', 'hr', className)}
      {...domProps}
    >
      {children}
    
    </hr>
  );
});

Hr.displayName = 'Hr';

export default Hr;
